module.exports = __webpack_public_path__ + "static/img/2014.e7792a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2014.png
// module id = 1dTV
// module chunks = 1